import { extractAvgColor } from "../utilities/color";
import { ColorModule } from "./color.module";
import { DebounceModule } from "./debounce.module";

export class JumbotronColorModule extends ColorModule {
    breakPointCache = [
        'xs',
        'md',
        'lg',
        'xl',
        'xxl',
    ]
  constructor(jumbotron, extraConfiguration = {}) {
    super(extraConfiguration);
    this.jumbotron = jumbotron;

    this.debounceModule = new DebounceModule();


    this.initialize();
  }

  initialize() {
    window.addEventListener("load", () => {
      const jumbotrons = document.querySelectorAll(".jumbotron");
      jumbotrons.forEach((jumbotron) => {
        this.measureJumbotronContent(jumbotron);
        this.setupVideoMeasuring(jumbotron);
      });
    });

      // Debounce resize events to avoid performance issues
      window.addEventListener("resize",
          this.debounceModule.debounce(() => {
          const jumbotrons = document.querySelectorAll(".jumbotron");
          jumbotrons.forEach((jumbotron) => {
              this.measureJumbotronContent(jumbotron);
          });
        }, 200)
      );

    // window.addEventListener('resize',
    //   this.debounceModule.debounce(() => this.measureJumbotronContent(), 100)
    // );
  }

  measureJumbotronContent(jumbotron) {

    if (jumbotron) {
      let jumbotronVideos = jumbotron.querySelectorAll(".jumbotron-video");
      if (jumbotronVideos) {
        const visibleVideos = Array.from(jumbotronVideos)
          .filter(jumbotron => this.isElementVisible(jumbotron))
          .map(jumbotron => jumbotron.querySelector("video"))
          .filter(Boolean);

        if (visibleVideos.length > 0) {
          visibleVideos.forEach(video => {
            if (video.readyState >= 2) {
              this.measureVideo(video, jumbotron).then(() => {
                // console.log('measured video at video ready state 2 or greater');
              });
            } else {
              video.addEventListener("loadeddata", () => {
                this.measureVideo(video, jumbotron).then(() => {
                  // console.log('measured video after video data loaded');
                });
              }, { once: true });
            }
          });
          return;
        }
      }
    }

    if (jumbotron) {
      // Fix: Use getAttribute instead of dataset to be more reliable

        let backgroundElements = [];

        let smallJumbotronVisible = this.isSmallJumbotronImageVisible();
        let largeJumbotronVisible = this.isLargeJumbotronImageVisible();
        console.log('smallJumbotronVisible', smallJumbotronVisible);
        console.log('largeJumbotronVisible', largeJumbotronVisible);

        let smallJumbotronBackgroundContainers = jumbotron.querySelectorAll('.jumbotron-background-container-small');
        let largeJumbotronBackgroundContainers = jumbotron.querySelectorAll('.jumbotron-background-container-large');

        if (smallJumbotronVisible === true && smallJumbotronBackgroundContainers) {
            smallJumbotronBackgroundContainers.forEach((smallJumbotronBackgroundContainer) => {
                backgroundElements.push(smallJumbotronBackgroundContainer);
            });
        }

        if (largeJumbotronVisible === true && largeJumbotronBackgroundContainers) {
            largeJumbotronBackgroundContainers.forEach((largeJumbotronBackgroundContainer) => {
                backgroundElements.push(largeJumbotronBackgroundContainer);
            });
        }

        console.log('result for visible background elements is', backgroundElements);

        if (backgroundElements.length > 0) {
        backgroundElements.forEach(backgroundElement =>
          this.measureImage(backgroundElement, jumbotron));
      }
    }
  }

  setupVideoMeasuring(jumbotron) {
    if (jumbotron) {
      const videoElements = jumbotron.querySelectorAll("video");

      videoElements.forEach((video) => {
        video.play();

        if (!video.previousTimerUpdate) {
          video.previousTimerUpdate = 0;
        }

        if (!video.timeUpdateHandler) {
          video.timeUpdateHandler = () => {
            if (Math.abs(video.currentTime - video.previousTimerUpdate) > 5 || !video.previousTimerUpdate) {
              video.previousTimerUpdate = video.currentTime;
              this.measureVideo(video, jumbotron).then((v) => {
                // console.log('video measured after timeupdate');
              });
            }
          };
        }

        video.addEventListener("timeupdate", video.timeUpdateHandler);
        this.measureVideo(video, jumbotron).then(() => {
          // console.log('initial video measurement');
        });
      });
    }
  }

  async measureVideo(video, jumbotron) {
    // console.log('measureVideo', video);
    const videoContainer = video.closest(".jumbotron-video");

    if (videoContainer && !this.isElementVisible(videoContainer)) {
      return;
    }

    let cachedVideo = document.createElement('video');
    cachedVideo = video; // assign the actual video to a local cached video property

    cachedVideo.width = parseInt(video.videoWidth * 0.01);
    cachedVideo.height = parseInt(video.videoHeight * 0.01);

    // debug: document.documentElement.insertAdjacentElement('beforeend', cachedVideo);

    let canvas = document.createElement("canvas");
    canvas.width = cachedVideo.width;
    canvas.height = cachedVideo.height;

    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, cachedVideo.width, cachedVideo.height);

    const imageData = context.getImageData(
      0, 0, canvas.width, canvas.height,
      { willReadFrequently: true }
    );

    canvas = null; // unset, marking it garbage collectable

    const [r, g, b] = extractAvgColor(imageData);
    this.onMeasured([r, g, b], jumbotron);

  }

  isElementVisible(element) {
      // Note: this method seems incorrect, as the jumbotron is 'visible' (or more precise: potentially actually visible) on all screen sizes, regardless of a small or large background image being visible...

    if (!element) return false;

    const computedStyle = window.getComputedStyle(element);

    const isVideo = element.tagName === 'VIDEO' || element.querySelector('video');

    if (!isVideo && computedStyle.backgroundImage === 'none' && !element.getAttribute('data-bg')) {
      return false;
    }

    return true;
  }

  // Override from parent class
  measureImage(imageElement, element) {
    // if (!this.isElementVisible(imageElement)) return;
    super.measureImage(imageElement, element);
  }

  async onMeasured(rgb, element) {
    super.onMeasured(rgb, element).then((mode) => {
      // console.log('mode...', mode);
      let firstJumbo = document.querySelector('.jumbotron');
      if (firstJumbo) {
        // console.log('firstJumbo', firstJumbo, 'and element', element)
        if (element == firstJumbo) {
          // console.log('same, will set header theme');
          this.setTheme(document.querySelector("header"), mode);
        }
        if (element.classList.contains('jumbotron')) {
          this.setTheme(element, mode);
        }
      }
    });
  }

    getBreakPoint() {
        let bodyStyle = getComputedStyle(document.querySelector('body'));
        if (bodyStyle) {
            let breakPoint = bodyStyle.getPropertyValue('--current-breakpoint');
            return breakPoint;
        }
    }

    screenIsLargerThanExtraSmall(breakPoint) {
        switch (breakPoint) {
            case 'sm':
            case 'md':
            case 'lg':
            case 'xl':
            case 'xxl':
                return true;
            default:
                return false;
        }
    }

    isSmallJumbotronImageVisible(element) {
        // Probably we can take a simpler approach:
        // - just assume that when breakpoint of html is xs:
        // :root {
        //   --current-breakpoint: xs;
        // }
        // that the small image is visible
        // and if the breakpoint is larger, like sm, md, xl, xxl:
        //   :root {
        //   --current-breakpoint: xs;
        // }
        // then the large image is visible.

        let currentBreakPoint = this.getBreakPoint();
        console.log('currentBreakPoint visibility result', currentBreakPoint);

        if (currentBreakPoint === 'xs') {
            return true;
        }
        return false;
    }

    isLargeJumbotronImageVisible(element) {
        // Probably we can take a simpler approach:
        // - just assume that when breakpoint of html is xs:
        // :root {
        //   --current-breakpoint: xs;
        // }
        // that the small image is visible
        // and if the breakpoint is larger, like sm, md, xl, xxl:
        //   :root {
        //   --current-breakpoint: xs;
        // }
        // then the large image is visible.


        let currentBreakPoint = this.getBreakPoint();
        console.log('currentBreakPoint visibility result', currentBreakPoint);

        if (
            currentBreakPoint === 'sm'
            ||
            currentBreakPoint === 'md'
            ||
            currentBreakPoint === 'lg'
            ||
            currentBreakPoint === 'xl'
            ||
            currentBreakPoint === 'xxl'
        ) {
            return true;
        }
        return false;
    }

}